<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 559 560">
    <g id="Microbus" transform="translate(-443 -117)">
      <g id="Group_938" data-name="Group 938" transform="translate(619.818 620.641) rotate(-90)">
        <path
          id="Path_623"
          data-name="Path 623"
          d="M0,0"
          transform="translate(396.477 151.372)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_631"
          data-name="Path 631"
          d="M10.1,0S23.759,1.52,27.6,7.615,40.8,32.56,40.8,73.532c0,0-1.5,49-13.243,58.739,0,0-5,9.849-27.559,9.04"
          transform="translate(329.563 23.888)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_926" data-name="Group 926" transform="translate(357.619 33.487)">
          <path
            id="Path_632"
            data-name="Path 632"
            d="M0,58.3l3.616-5.225a10.707,10.707,0,0,0,8.83-7.216c2.332-6.729,6.095-22,4.59-23.434s-3.687-3.687-3.687-3.687L14.327,0"
            transform="translate(0 63.933)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_633"
            data-name="Path 633"
            d="M0,0,3.457,5.225A10.275,10.275,0,0,1,11.9,12.441c2.23,6.729,5.827,22,4.388,23.433s-3.525,3.687-3.525,3.687l.8,24.371"
            transform="translate(0.764)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_634"
          data-name="Path 634"
          d="M0,3.338S35.893,2.681,46.691,0"
          transform="translate(341.621 153.527)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_635"
          data-name="Path 635"
          d="M0,0S38.526.667,46.691,3.009"
          transform="translate(341.621 31.654)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_636"
          data-name="Path 636"
          d="M.358,141.339,0,140.229s23.377,3.413,23.1-66.669c0,0,2.37-70.369-22.743-73.56"
          transform="translate(329.206 23.86)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_637"
          data-name="Path 637"
          d="M0,0"
          transform="translate(343.088 153.527)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_638"
          data-name="Path 638"
          d="M0,0"
          transform="translate(344.293 134.253)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_644"
          data-name="Path 644"
          d="M37.5,0,1.721,3.236S-.367,3.048.141,6.265c0,0,4.628,17.382,4.628,61.232,0,0-2.191,51.15-4.707,56.107,0,0-.56,1.872,1.7,2.192S37.5,128.6,37.5,128.6s1.354.68,2.333-2.519S50.881,96.09,49.994,67.191C49.994,67.191,48.261,6.1,37.5,0Z"
          transform="translate(296.972 29.923)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_645"
          data-name="Path 645"
          d="M0,1.707,1.583,0,38.4,3.8s-3.442,2.812-7.318,2.568Z"
          transform="translate(298.126 157.725)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_646"
          data-name="Path 646"
          d="M0,4.843,1.583,6.549,38.4,2.754a9.045,9.045,0,0,0-6.6-2.739Z"
          transform="translate(298.279 24.379)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_661"
          data-name="Path 661"
          d="M0,27.54l34.159,2.935L32.591,1.129.987,0"
          transform="translate(248.607 104.418)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_662"
          data-name="Path 662"
          d="M0,2.935,34.159,0,32.591,29.346.987,30.475"
          transform="translate(248.607 53.318)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_189"
          data-name="Rectangle 189"
          width="42.309"
          height="63.942"
          rx="21.154"
          transform="translate(178.89 62.627)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_932" data-name="Group 932" transform="translate(143.722 17.513)">
          <path
            id="Path_664"
            data-name="Path 664"
            d="M96.467.082V21.377H0V0Z"
            transform="translate(0 3.342)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_665"
            data-name="Path 665"
            d="M0,0,.527,1.354H83.562"
            transform="translate(5.945 20.129)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_933" data-name="Group 933" transform="translate(143.722 146.857)">
          <path
            id="Path_669"
            data-name="Path 669"
            d="M0,1.354.527,0H83.562"
            transform="translate(5.945 3.236)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_934" data-name="Group 934" transform="translate(54.328 146.857)">
          <path
            id="Path_672"
            data-name="Path 672"
            d="M0,1.058.481,0H76.263"
            transform="translate(6.17 3.532)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_935" data-name="Group 935" transform="translate(54.328 20.855)">
          <path
            id="Path_675"
            data-name="Path 675"
            d="M0,0,.481,1.058H76.263"
            transform="translate(6.17 16.787)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_936" data-name="Group 936" transform="translate(39.26 141.2)">
          <path
            id="Path_677"
            data-name="Path 677"
            d="M3.01,5.658c14.447-1.279,45.449,6.669,45.449,6.669s8.428,3.338,9.03,0c.6-5.3-1.354-4.487-1.354-4.487C27.664-.689,0,.014,0,.014"
            transform="translate(197.918 0)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_678"
            data-name="Path 678"
            d="M253.752,7.99S222.449,0,204.239,0H0"
            transform="translate(0 3.01)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_937" data-name="Group 937" transform="translate(39.26 34.128)">
          <path
            id="Path_679"
            data-name="Path 679"
            d="M0,13.8s27.664.7,56.134-7.826c0,0,1.956.808,1.354-4.487-.6-3.339-9.03,0-9.03,0s-31,7.948-45.449,6.669"
            transform="translate(197.918 0)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_680"
            data-name="Path 680"
            d="M253.752,0s-31.3,7.99-49.512,7.99H0"
            transform="translate(0 2.811)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <line
          id="Line_44"
          data-name="Line 44"
          x2="10.779"
          transform="translate(25.434 144.21)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_45"
          data-name="Line 45"
          x1="10.779"
          transform="translate(25.434 44.928)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_687"
          data-name="Path 687"
          d="M4.628,0,1.354,1.919,0,25.057l2.935,2.257"
          transform="translate(3.65 46.29)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_688"
          data-name="Path 688"
          d="M2.911.882,0,0V36.344L2.935,35.1"
          transform="translate(3.65 76.087)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_689"
          data-name="Path 689"
          d="M3.5,0,0,2.145l1.749,22.8L4.775,26.98"
          transform="translate(3.085 115.366)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_690"
          data-name="Path 690"
          d="M0,0"
          transform="translate(23.477 146.857)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_691"
          data-name="Path 691"
          d="M0,0"
          transform="translate(20.467 145.051)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_693"
          data-name="Path 693"
          d="M0,.045S33.124-4.331,33.23,73.1c0,0,3.04,61.176-33.23,67.271"
          transform="translate(369.312 24.322)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_190"
          data-name="Rectangle 190"
          width="33.861"
          height="21.377"
          transform="translate(20.467 146.857)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_694"
          data-name="Path 694"
          d="M0,1.058V0H11.795"
          transform="translate(24.418 150.389)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_695"
          data-name="Path 695"
          d="M0,0H9.538V.757"
          transform="translate(39.26 150.389)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_696"
          data-name="Path 696"
          d="M.051,1.806S-1.472,0,12.072,0"
          transform="translate(24.141 155.435)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_697"
          data-name="Path 697"
          d="M0,.071S8.353-.55,9.538,1.877"
          transform="translate(39.26 155.364)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_698"
          data-name="Path 698"
          d="M0,1.844S4.966,2.314,5.418,0"
          transform="translate(43.38 164.126)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_699"
          data-name="Path 699"
          d="M7.393,1.844S-.056,2.314,0,0"
          transform="translate(24.418 164.126)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_192"
          data-name="Rectangle 192"
          width="33.861"
          height="21.377"
          transform="translate(20.467 20.855)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_700"
          data-name="Path 700"
          d="M0,0V1.058H11.795"
          transform="translate(24.418 37.642)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_701"
          data-name="Path 701"
          d="M0,.757H9.538V0"
          transform="translate(39.26 37.943)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_702"
          data-name="Path 702"
          d="M.051,0s-1.524,1.806,12.02,1.806"
          transform="translate(24.141 31.848)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_703"
          data-name="Path 703"
          d="M0,1.806S8.353,2.427,9.538,0"
          transform="translate(39.26 31.848)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_704"
          data-name="Path 704"
          d="M0,.039s4.966-.47,5.418,1.844"
          transform="translate(43.38 23.08)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_705"
          data-name="Path 705"
          d="M7.393.039S-.056-.431,0,1.883"
          transform="translate(24.418 23.08)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <text
        id="Microbus-2"
        data-name="Bus"
        transform="translate(690 130)"
        font-size="14"
        font-weight="700"
      >
        <tspan x="0" y="0">Bus</tspan>
      </text>

      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['logo'] || ''"
        [attr.data-name]="'exterior.microbus.logo' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="69"
          height="18"
          rx="9"
          transform="translate(529 135)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 135)"
        />
        <g class="arrow" id="Arrow">
          <path
            id="Path_379"
            data-name="Path 379"
            d="M6274,1046.656l-93.924-67H6157"
            transform="translate(-5558.001 -835.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_76"
            data-name="Ellipse 76"
            cx="3"
            cy="3"
            r="3"
            transform="translate(713 208)"
            fill="#696969"
          />
        </g>
        <ellipse
          class="parts"
          id="Logo-2"
          data-name="Logo"
          cx="1.303"
          cy="2.483"
          rx="1.303"
          ry="2.483"
          transform="translate(714.755 214.73) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Logo-3"
          data-name="Logo"
          transform="translate(548 147)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="-5" y="0">{{ 'exterior.microbus.logo' | translate }}</tspan>
        </text>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(582 147)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.lft_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="108"
          height="18"
          rx="9"
          transform="translate(490 166)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 166)"
        />
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_378"
            data-name="Path 378"
            d="M6227.539,1024.656l-56.625-45H6157"
            transform="translate(-5559.539 -803.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_109"
            data-name="Ellipse 109"
            cx="3"
            cy="3"
            r="3"
            transform="translate(665 218)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Head_Lamp-2"
          data-name="LFT Head Lamp"
          d="M0,.005S6.076-.6,11.192,11.44,16.73,28.016,14.9,29.059C14.9,29.059,11.607,9.79,0,.005Z"
          transform="translate(650.417 234.153) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(582 178)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="LFT_Head_Lamp-3"
          data-name="LFT Head Lamp"
          transform="translate(497 178)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_head_lamp' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.lft_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="133"
          height="18"
          rx="9"
          transform="translate(465 197)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 197)"
        />
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_377"
            data-name="Path 377"
            d="M6216.91,1004.037l-48.093-24.381H6157"
            transform="translate(-5559.539 -774.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_108"
            data-name="Ellipse 108"
            cx="3"
            cy="3"
            r="3"
            transform="translate(653 226)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_lamp-2"
          data-name="LFT Indicator lamp"
          d="M0,.025S2.279-.361,5.292,1.909L4.018,3.448A15.753,15.753,0,0,0,0,.025Z"
          transform="translate(650.743 233.015) rotate(-82)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_lamp-3"
          data-name="LFT Indicator lamp"
          transform="translate(482 209)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(582 209)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['wind_screen'] || ''"
        [attr.data-name]="'exterior.microbus.wind_screen' | translate"
      >
        <path
          id="Path_341"
          data-name="Path 341"
          d="M8.429,0H83.357c4.655,0,8.429,4.029,8.429,9s-3.774,9-8.429,9H8.429C3.774,18,0,13.971,0,9S3.774,0,8.429,0Z"
          transform="translate(506 254)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(579.786 254)"
        />
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_375"
            data-name="Path 375"
            d="M6285.539,1012.656l-103.186-33-25.827,3.916"
            transform="translate(-5559.539 -720.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_106"
            data-name="Ellipse 106"
            cx="3"
            cy="3"
            r="3"
            transform="translate(723 289)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Wind_Screen-2"
          data-name="Wind Screen"
          d="M8.017,79.686V43.794s-4.364-2.032-4.364-3.988L.04,6.17S-.562,2.709,2.9,2.257,29.97,0,29.97,0,40.824.066,42.028,64.708c0,0-1.843,58.1-12.058,58.887L3.05,121.871a4.079,4.079,0,0,1-2.483-4.6L3.953,83.3Z"
          transform="translate(652.225 320.306) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(582.786 265)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="Wind_Screen-3"
          data-name="Wind Screen"
          transform="translate(512 266)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.wind_screen' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_lft_panel'] || ''"
        [attr.data-name]="'exterior.microbus.lft_frt_panel' | translate"
      >
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(500 283)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(581 283)"
        />
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_374"
            data-name="Path 374"
            d="M6157,996.656l34.634-17h8.511"
            transform="translate(-5558 -704.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_105"
            data-name="Ellipse 105"
            cx="3"
            cy="3"
            r="3"
            transform="translate(638 272)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Panel-2"
          data-name="LFT FRT Panel"
          d="M43.982,4.289S39.731,0,0,0V2.709S3.951,2.37,4.233,3.781c0,0,26.186-.96,37.247,4.684,0,0,2.032,1.072,2.822,0s-2.652-2.314-8.3-3.725l-.113-.9Z"
          transform="translate(639.896 295.311) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Panel-3"
          data-name="LFT FRT Panel"
          transform="translate(505 295)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_frt_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(584 294)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_r.v_mirror'] || ''"
        [attr.data-name]="'exterior.microbus.lft_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="104"
          height="18"
          rx="9"
          transform="translate(494 313)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 313)"
        />
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_373"
            data-name="Path 373"
            d="M6188.2,979.656l-25.045,18.572H6157"
            transform="translate(-5558.549 -675.682)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_104"
            data-name="Ellipse 104"
            cx="3"
            cy="3"
            r="3"
            transform="translate(627 302)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="LFT_R.V_Mirror_2" data-name="LFT R.V Mirror ">
          <path
            id="Path_650"
            data-name="Path 650"
            d="M1.2,0S.716,3.687.039,3.875,7.789,5,7.564,0Z"
            transform="translate(641.617 304.755) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_651"
            data-name="Path 651"
            d="M0,1.524V6.885H3.243V0A7.71,7.71,0,0,1,0,1.524Z"
            transform="translate(634.732 302.535) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_652"
            data-name="Path 652"
            d="M0,1.445,4.74,17.4s5.569-2.333,5.945-3.762S7.3,1.445,7.3,1.445,6.17-.813,3.085.316Z"
            transform="translate(619.818 308.893) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="LFT_R.V_Mirror_3"
          data-name="LFT R.V Mirror "
          transform="translate(503 325)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(582 324)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['driver_door_with_window'] || ''"
        [attr.data-name]="'exterior.microbus.driver_door_with_window' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="155"
          height="18"
          rx="9"
          transform="translate(443 343)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 343)"
        />
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_372"
            data-name="Path 372"
            d="M6198.539,979.657l-33.346,20.092H6157"
            transform="translate(-5558.539 -647.749)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_103"
            data-name="Ellipse 103"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 328)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="_Driver_Door_with_Window-2" data-name=" Driver Door with Window">
          <path
            id="Path_660"
            data-name="Path 660"
            d="M0,3.342,3.809,3.3,4.881,1.637h8.663l1.749,1.439,3.217-.028L15.519,0H3.075Z"
            transform="translate(637.331 372.034) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_657"
            data-name="Path 657"
            d="M85.142,0,0,.828V10.4s86.384.856,85.142-7.69Z"
            transform="translate(639.927 380.453) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_658"
            data-name="Path 658"
            d="M0,5.533,5.267.325S26.186-.437,27.014.372,27.465,2.243,24,3.029,0,5.533,0,5.533Z"
            transform="translate(642.722 333.273) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(582 354)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="_Driver_Door_with_Window-3"
          data-name=" Driver Door with Window"
          transform="translate(450 355)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0" xml:space="preserve">
            {{ 'exterior.microbus.driver_door_with_window' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['2nd_window'] || ''"
        [attr.data-name]="'exterior.microbus.2nd_window' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(499 372)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 372)"
        />
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_371"
            data-name="Path 371"
            d="M6202.715,979.656l-36.7,13H6157"
            transform="translate(-5558.539 -610.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_101"
            data-name="Ellipse 101"
            cx="3"
            cy="3"
            r="3"
            transform="translate(644 365)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="_2nd_Window-2"
          data-name="2nd Window"
          d="M43.363.075,38.7,5.283,1.525,5.9S-.205,5.521.02,4.017.171.367,3.181.123,43.363.075,43.363.075Z"
          transform="translate(642.971 374.378) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_2nd_Window-3"
          data-name="2nd Window"
          transform="translate(513 384)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.2nd_window' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(582 383)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['3rd_window'] || ''"
        [attr.data-name]="'exterior.microbus.3rd_window' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="100"
          height="18"
          rx="9"
          transform="translate(498 402)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 402)"
        />
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_370"
            data-name="Path 370"
            d="M6205.818,1006.46l-39.189-26.8H6157"
            transform="translate(-5558.539 -568.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_100"
            data-name="Ellipse 100"
            cx="3"
            cy="3"
            r="3"
            transform="translate(645 435)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="_3rd_Window-2"
          data-name="3rd Window"
          d="M0,1.866V8.245a5.005,5.005,0,0,0,4.74,2.516h76.3s2.516-.86,2.989-2.989,0-7.737,0-7.737H1.731S0-.406,0,1.866Z"
          transform="translate(642.937 470.975) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(582 413)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="_3rd_Window-3"
          data-name="3rd Window"
          transform="translate(515 414)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.3rd_window' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['nth_window'] || ''"
        [attr.data-name]="'exterior.microbus.nth_window' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="98"
          height="18"
          rx="9"
          transform="translate(500 431)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 431)"
        />
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_369"
            data-name="Path 369"
            d="M6208.764,1040.656l-41.554-61H6157"
            transform="translate(-5558.539 -541.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_99"
            data-name="Ellipse 99"
            cx="3"
            cy="3"
            r="3"
            transform="translate(648 497)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Nth_Window-2"
          data-name="Nth Window"
          d="M0,1.866V8.245a4.561,4.561,0,0,0,4.33,2.516H74.019a4.571,4.571,0,0,0,2.729-2.989c.432-2.128,0-7.737,0-7.737H1.581S0-.406,0,1.866Z"
          transform="translate(642.937 560.143) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(582 442)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="Nth_Window-3"
          data-name="Nth Window"
          transform="translate(514 443)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.nth_window' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_panel'] || ''"
        [attr.data-name]="'exterior.microbus.lft_rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="98"
          height="18"
          rx="9"
          transform="translate(500 461)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 461)"
        />
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_368"
            data-name="Path 368"
            d="M6198.258,1031.383l-33.12-51.727H6157"
            transform="translate(-5558.539 -510.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_98"
            data-name="Ellipse 98"
            cx="3"
            cy="3"
            r="3"
            transform="translate(636 517)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Panel-2"
          data-name="LFT RR Panel"
          d="M89.393.082V21.377H0V0Z"
          transform="translate(640.673 566.313) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Panel-3"
          data-name="LFT RR Panel"
          transform="translate(510 473)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(582 472)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['fuel_flap'] || ''"
        [attr.data-name]="'exterior.microbus.fuel_flap' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="78"
          height="18"
          rx="9"
          transform="translate(520 491)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 491)"
        />
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_367"
            data-name="Path 367"
            d="M6205.818,1058.523l-39.189-78.867H6157"
            transform="translate(-5558.539 -480.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_97"
            data-name="Ellipse 97"
            cx="3"
            cy="3"
            r="3"
            transform="translate(644 575)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="Fuel_Flap-2"
          data-name="Fuel Flap"
          width="8.385"
          height="4.819"
          rx="2.41"
          transform="translate(645.71 587.972) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Fuel_Flap-3"
          data-name="Fuel Flap"
          transform="translate(530 503)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.fuel_flap' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(582 502)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.lft_rr_indicator_lamp' | translate"
      >
        <path
          class="parts"
          id="LFT_Indicator_lamp-5"
          data-name="LFT Indicator lamp"
          d="M0,11.521H6.546v1.806H9.782V0H3.988S.259.377.259,3.729Z"
          transform="translate(650.475 609.956) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="134"
          height="18"
          rx="9"
          transform="translate(455 536)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(581 536)"
        />
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_365"
            data-name="Path 365"
            d="M6212.122,1038.63l-44.25-58.973H6157"
            transform="translate(-5558.539 -435.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_92"
            data-name="Ellipse 92"
            cx="3"
            cy="3"
            r="3"
            transform="translate(651 600)"
            fill="#696969"
          />
        </g>
        <text
          id="LFT_Indicator_lamp-6"
          data-name="LFT Indicator lamp"
          transform="translate(473 548)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(584 547)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_stop_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.lft_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(492 563)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 563)"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_366"
            data-name="Path 366"
            d="M6205.818,1015.11l-39.189-35.453H6157"
            transform="translate(-5558.539 -407.59)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_91"
            data-name="Ellipse 91"
            cx="3"
            cy="3"
            r="3"
            transform="translate(644 604)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Stop_Lamp-2"
          data-name="LFT Stop Lamp"
          d="M11.4,0,1.919,3.712A3.859,3.859,0,0,0,0,6.76v5.7l1.853,1.866s-.63-3.772,3.753-4.47H11.4V0"
          transform="translate(640.619 611.574) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Stop_Lamp-3"
          data-name="LFT Stop Lamp"
          transform="translate(501 575)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.lft_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(582 574)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.microbus.rr_bumper' | translate"
      >
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="103"
          height="18"
          rx="9"
          transform="translate(494 604)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 604)"
        />
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_363"
            data-name="Path 363"
            d="M6220.387,982.656l-50.885-3H6157"
            transform="translate(-5557.999 -366.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_93"
            data-name="Ellipse 93"
            cx="3"
            cy="3"
            r="3"
            transform="translate(659 613)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Bumper-2"
          data-name="RR Bumper"
          d="M9.067,123.024H5.117L1.354,111.459S0,74.3,0,64.669L1.806,12.178S4.816.344,5.719,0H8.648S5.263,61.961,6.375,64.669C6.375,64.669,7.6,120.2,9.067,123.024Z"
          transform="translate(652.568 620.641) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Bumper-3"
          data-name="RR Bumper"
          transform="translate(518 617)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rr_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(582 615)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_hatch_door_lock'] || ''"
        [attr.data-name]="'exterior.microbus.rr_hatch_door_lock' | translate"
      >
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_364"
            data-name="Path 364"
            d="M6271.377,978.664l-1.33,1.506-6.983,1.564-84.479,18.922H6157"
            transform="translate(-5567.539 -357.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_95"
            data-name="Ellipse 95"
            cx="3"
            cy="3"
            r="3"
            transform="translate(701 618)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Lock-2"
          data-name="Lock"
          d="M6175.937,2331.464l8.4.149h9.314v1.863l-9.314.509-8.4-.858Z"
          transform="translate(-5469 -1711)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="125"
          height="18"
          rx="9"
          transform="translate(461 634)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(579 634)"
        />
        <text
          id="Lock-3"
          data-name="Lock"
          transform="translate(485 646)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rr_hatch_door_lock' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(582 645)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_wind_screen'] || ''"
        [attr.data-name]="'exterior.microbus.rear_wind_screen' | translate"
      >
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="115"
          height="18"
          rx="9"
          transform="translate(655 646)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(753 646)"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_361"
            data-name="Path 361"
            d="M6157,1003.595l24.467-23.939h6.012"
            transform="translate(5778.816 -3036.486) rotate(135)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_94"
            data-name="Ellipse 94"
            cx="3"
            cy="3"
            r="3"
            transform="translate(712 605)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Rear_Wind_Screen-2"
          data-name="Rear Wind Screen"
          d="M8.408,102.873V0H1.862S-.8,20.63.244,55.242l1.618,49.437H8.408Z"
          transform="translate(661.996 611.818) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Rear_Wind_Screen-3"
          data-name="Rear Wind Screen"
          transform="translate(663 658)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rear_wind_screen' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(755 658)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.microbus.tyres' | translate"
      >
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(830 657)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 657)"
        />
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(852 669)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.microbus.tyres' | translate }}</tspan>
        </text>
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(832 668)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['others'] || ''"
        [attr.data-name]="'exterior.microbus.other_1' | translate"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(830 628)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 628)"
        />
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(852 640)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.other_1' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(832 639)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_panel'] || ''"
        [attr.data-name]="'exterior.microbus.rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(830 597)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 597)"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_511"
            data-name="Path 511"
            d="M6215.409,2325.935l15.784,19.05,68.306-26.553"
            transform="translate(-5469 -1711)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_96"
            data-name="Ellipse 96"
            cx="3"
            cy="3"
            r="3"
            transform="translate(743 612)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Panel-2"
          data-name="RR Panel"
          d="M2.692,122.513l1.853-1.866S2.58,68.9,2.692,64.159c0,0-.263-51.114,1.618-55.242l.235-7.051L2.692,0S-3.365,53.625,2.692,122.513Z"
          transform="translate(653.079 614.266) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Panel-3"
          data-name="RR Panel"
          transform="translate(852 609)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(832 608)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_stop_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.rht_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(830 566)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 566)"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_360"
            data-name="Path 360"
            d="M6162.215,1014.647l36.334-34.991h10.21"
            transform="translate(-5378.539 -405.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_90"
            data-name="Ellipse 90"
            cx="3"
            cy="3"
            r="3"
            transform="translate(781 606)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Stop_Lamp-2"
          data-name="RHT Stop Lamp"
          d="M11.4,14.326,1.919,10.613A3.859,3.859,0,0,1,0,7.566v-5.7L1.853,0s-.63,3.772,3.753,4.47H11.4v9.856"
          transform="translate(773.726 611.574) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(832 577)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="RHT_Stop_Lamp-3"
          data-name="RHT Stop Lamp"
          transform="translate(852 578)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_stop_lamp' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.rht_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="137"
          height="18"
          rx="9"
          transform="translate(840 536)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 536)"
        />
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_359"
            data-name="Path 359"
            d="M6152.349,1040.375l46.2-60.718h10.21"
            transform="translate(-5378.539 -435.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_89"
            data-name="Ellipse 89"
            cx="3"
            cy="3"
            r="3"
            transform="translate(771 602)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-2"
          data-name="RHT Indicator lamp"
          d="M0,1.806H6.546V0H9.782V13.327H3.988S.259,12.95.259,9.6Z"
          transform="translate(764.869 609.956) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Indicator_lamp-3"
          data-name="RHT Indicator lamp"
          transform="translate(852 548)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(832 547)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['roof'] || ''"
        [attr.data-name]="'exterior.microbus.roof' | translate"
      >
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="73"
          height="18"
          rx="9"
          transform="translate(830 495)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 495)"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_357"
            data-name="Path 357"
            d="M6157,1034.656l74.217-55h18.237"
            transform="translate(-5419.232 -475.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_88"
            data-name="Ellipse 88"
            cx="3"
            cy="3"
            r="3"
            transform="translate(736 555)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Roof-2"
          data-name="Roof"
          d="M1.072,110.756H218.366s9.861-2.421,48.912,7.744c0,0,5.48,1.451,5.566-1.075l2.3.63s10.547-71.6.321-117.218L275.278,0s-32.832,8.827-56.911,8.827H0Z"
          transform="translate(655.919 598.819) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Roof-3"
          data-name="Roof"
          transform="translate(852 507)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">{{ 'exterior.microbus.roof' | translate }}</tspan>
        </text>
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(832 506)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_panel'] || ''"
        [attr.data-name]="'exterior.microbus.rht_rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(830 464)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 464)"
        />
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_356"
            data-name="Path 356"
            d="M6157,1001.838l33.706-22.182h8.282"
            transform="translate(-5368.767 -506.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_87"
            data-name="Ellipse 87"
            cx="3"
            cy="3"
            r="3"
            transform="translate(786 492)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Panel-2"
          data-name="RHT Panel"
          d="M89.393,21.295V0H0V21.377Z"
          transform="translate(766.675 566.313) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Panel-3"
          data-name="RHT Panel"
          transform="translate(852 476)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(832 475)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['nth_rht_window'] || ''"
        [attr.data-name]="'exterior.microbus.nth_rht_window' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(840 433)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 433)"
        />
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_355"
            data-name="Path 355"
            d="M6157,1032.838l41.549-53.182h10.21"
            transform="translate(-5378.539 -537.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_86"
            data-name="Ellipse 86"
            cx="3"
            cy="3"
            r="3"
            transform="translate(777 491)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Nth_Window-5"
          data-name="Nth Window"
          d="M0,8.895V2.516A4.561,4.561,0,0,1,4.33,0H74.019a4.571,4.571,0,0,1,2.729,2.989c.432,2.128,0,7.737,0,7.737H1.581S0,11.167,0,8.895Z"
          transform="translate(775.027 560.143) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Nth_Window-6"
          data-name="Nth Window"
          transform="translate(852 445)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.nth_rht_window' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(832 444)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['3rd_rht_window'] || ''"
        [attr.data-name]="'exterior.microbus.3rd_rht_window' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(840 403)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 403)"
        />
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_354"
            data-name="Path 354"
            d="M6157,1006.006l41.549-26.35h10.21"
            transform="translate(-5378.539 -567.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_85"
            data-name="Ellipse 85"
            cx="3"
            cy="3"
            r="3"
            transform="translate(777 435)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="_3rd_Window-5"
          data-name="3rd Window"
          d="M0,8.895V2.516A5.005,5.005,0,0,1,4.74,0h76.3s2.516.86,2.989,2.989,0,7.737,0,7.737H1.731S0,11.167,0,8.895Z"
          transform="translate(775.027 470.975) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3rd_Window-6"
          data-name="3rd Window"
          transform="translate(852 415)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.3rd_rht_window' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(832 414)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['main_passenger_door'] || ''"
        [attr.data-name]="'exterior.microbus.main_passenger_door' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="137"
          height="18"
          rx="9"
          transform="translate(832 377)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 377)"
        />
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_510"
            data-name="Path 510"
            d="M6157,985.528l35.48-5.871h8.719"
            transform="translate(-5368.978 -593.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_84"
            data-name="Ellipse 84"
            cx="3"
            cy="3"
            r="3"
            transform="translate(785 389)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Main_Passenger_Door-2" data-name="Main Passenger Door">
          <path
            id="Path_668"
            data-name="Path 668"
            d="M96.467,21.295V0H0V21.377Z"
            transform="translate(766.675 476.919) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_667"
            data-name="Path 667"
            d="M0,0,3.809.037,4.881,1.705h8.663L15.293.266,18.51.294,15.519,3.342H3.075Z"
            transform="translate(788.052 410.109) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Main_Passenger_Door-3"
          data-name="Main Passenger Door"
          transform="translate(852 389)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.main_passenger_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(834 388)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['2nd_rht_window'] || ''"
        [attr.data-name]="'exterior.microbus.2nd_rht_window' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(840 351)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 351)"
        />
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_353"
            data-name="Path 353"
            d="M6157,985.528l35.48-5.871h8.719"
            transform="translate(-5370.978 -619.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_83"
            data-name="Ellipse 83"
            cx="3"
            cy="3"
            r="3"
            transform="translate(783 363)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="_2nd_Window-5"
          data-name="2nd Window"
          d="M43.363,5.822,38.7.614,1.525,0S-.205.376.02,1.881s.15,3.65,3.16,3.894S43.363,5.822,43.363,5.822Z"
          transform="translate(779.856 374.378) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_2nd_Window-6"
          data-name="2nd Window"
          transform="translate(854 363)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.2nd_rht_window' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(832 362)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['passenger_door_with_window'] || ''"
        [attr.data-name]="'exterior.microbus.passenger_door_with_window' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="172"
          height="18"
          rx="9"
          transform="translate(830 320)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 320)"
        />
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_352"
            data-name="Path 352"
            d="M6157,979.656l33.088.547h8.131"
            transform="translate(-5368 -649.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_82"
            data-name="Ellipse 82"
            cx="3"
            cy="3"
            r="3"
            transform="translate(786 327)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Passenger_Door_with_Window-2" data-name="Passenger Door with Window">
          <path
            id="Path_653"
            data-name="Path 653"
            d="M85.142,10.423,0,9.595V.024s86.384-.856,85.142,7.69Z"
            transform="translate(778.375 380.453) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_654"
            data-name="Path 654"
            d="M0,0,5.267,5.208s20.919.762,21.746-.047S27.465,3.29,24,2.5,0,0,0,0Z"
            transform="translate(780.471 333.273) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_656"
            data-name="Path 656"
            d="M0,0,3.809.037,4.881,1.705h8.663L15.293.266,18.51.294,15.519,3.342H3.075Z"
            transform="translate(788.052 372.034) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Passenger_Door_with_Window-3"
          data-name="Passenger Door with Window"
          transform="translate(852 333)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.passenger_door_with_window' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(832 331)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_r.v_mirror'] || ''"
        [attr.data-name]="'exterior.microbus.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(830 289)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 289)"
        />
        <g class="parts" id="RHT_R.V_Mirror-2" data-name="RHT R.V Mirror">
          <path
            id="Path_647"
            data-name="Path 647"
            d="M1.2,4.068S.716.38.039.192,7.789-.936,7.564,4.068Z"
            transform="translate(782.36 304.755) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_648"
            data-name="Path 648"
            d="M0,5.361V0H3.243V6.885A7.71,7.71,0,0,0,0,5.361Z"
            transform="translate(786.428 302.535) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_649"
            data-name="Path 649"
            d="M0,15.952,4.74,0s5.569,2.332,5.945,3.762S7.3,15.952,7.3,15.952,6.17,18.21,3.085,17.081Z"
            transform="translate(790.83 308.893) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_351"
            data-name="Path 351"
            d="M6157,985.084l25.5-5.428h6.267"
            transform="translate(-5358.55 -681.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_81"
            data-name="Ellipse 81"
            cx="3"
            cy="3"
            r="3"
            transform="translate(795 300)"
            fill="#696969"
          />
        </g>
        <text
          id="RHT_R.V_Mirror-3"
          data-name="RHT R.V Mirror"
          transform="translate(852 302)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(832 300)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_frt_panel'] || ''"
        [attr.data-name]="'exterior.microbus.rht_frt_panel' | translate"
      >
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="118"
          height="18"
          rx="9"
          transform="translate(830 258)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832.024 255.762) rotate(17)"
        />
        <g class="arrow" id="Arrow-29" data-name="Arrow">
          <path
            id="Path_350"
            data-name="Path 350"
            d="M6157,979.656l35.5,2.487h8.724"
            transform="translate(-5371 -713.597)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_80"
            data-name="Ellipse 80"
            cx="3"
            cy="3"
            r="3"
            transform="translate(785 263)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_FRT_Panel-2"
          data-name="RHT FRT Panel"
          d="M43.982,4.653S39.731,8.942,0,8.942V6.233s3.951.339,4.233-1.072c0,0,26.186.96,37.247-4.684,0,0,2.032-1.072,2.822,0S41.649,2.79,36.006,4.2l-.113.9Z"
          transform="translate(779.856 295.311) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_FRT_Panel-3"
          data-name="RHT FRT Panel"
          transform="translate(852 270)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_frt_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(832 269)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.rht_indicator_lamp' | translate"
      >
        <g class="arrow" id="Arrow-30" data-name="Arrow">
          <path
            id="Path_349"
            data-name="Path 349"
            d="M6157,979.656l38.4,3.634h9.436"
            transform="translate(-5374.614 -747.29)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_79"
            data-name="Ellipse 79"
            cx="3"
            cy="3"
            r="3"
            transform="translate(777 229)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-5"
          data-name="RHT Indicator lamp"
          d="M0,3.423s2.279.386,5.292-1.884L4.018,0A15.753,15.753,0,0,1,0,3.423Z"
          transform="translate(774.095 234.281) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="127"
          height="18"
          rx="9"
          transform="translate(830 227)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-32"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 227)"
        />
        <text
          id="RHT_Indicator_lamp-6"
          data-name="RHT Indicator lamp"
          transform="translate(852 239)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-32"
          data-name="3.0"
          transform="translate(832 238)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_head_lamp'] || ''"
        [attr.data-name]="'exterior.microbus.rht_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-32"
          data-name="Rectangle 38"
          width="114"
          height="18"
          rx="9"
          transform="translate(830 196)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-33"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 196)"
        />
        <g class="arrow" id="Arrow-31" data-name="Arrow">
          <path
            id="Path_348"
            data-name="Path 348"
            d="M6157,1001.11l47.048-21.453h11.562"
            transform="translate(-5385.39 -774.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_78"
            data-name="Ellipse 78"
            cx="3"
            cy="3"
            r="3"
            transform="translate(769 224)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Head_Lamp-2"
          data-name="RHT Head Lamp"
          d="M14.8,0s1.578.5,1.8,1.066S11.743,29.37,0,28.913C0,28.913,9.216,24.192,14.8,0Z"
          transform="translate(748.625 234.281) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Head_Lamp-3"
          data-name="RHT Head Lamp"
          transform="translate(852 208)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.rht_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-33"
          data-name="3.0"
          transform="translate(832 207)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.microbus.frt_bumper' | translate"
      >
        <rect
          id="Rectangle_38-33"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(830 165)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-34"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 165)"
        />
        <g class="arrow" id="Arrow-32" data-name="Arrow">
          <path
            id="Path_347"
            data-name="Path 347"
            d="M6157,1023.11l75.617-43.453H6251.2"
            transform="translate(-5420.978 -805.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_77"
            data-name="Ellipse 77"
            cx="3"
            cy="3"
            r="3"
            transform="translate(734 215)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Bumper-2"
          data-name="FRT Bumper"
          d="M1.2,140.561s21.069-.6,27.164-13.318c0,0,12.04-11.447,12.04-54.258s-12.04-60.108-12.04-60.108S23.628,2.558,0,0C0,0,16.479,1.956,22.123,10.2s14,17.721,14.447,63.095c0,0,.9,36.344-14.146,56.586C12.265,140.578,1.2,140.561,1.2,140.561Z"
          transform="translate(643.947 252.533) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Bumper-3"
          data-name="FRT Bumper"
          transform="translate(852 177)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.frt_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-34"
          data-name="3.0"
          transform="translate(832 176)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.microbus.frt_grill' | translate"
      >
        <rect
          id="Rectangle_38-34"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(830 134)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-35"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(830 134)"
        />
        <g class="arrow" id="Arrow-33" data-name="Arrow">
          <path
            id="Path_346"
            data-name="Path 346"
            d="M6157,1047.591l84.955-67.934h20.876"
            transform="translate(-5432.611 -836.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_61"
            data-name="Ellipse 61"
            cx="3"
            cy="3"
            r="3"
            transform="translate(721 209)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Grill-2"
          data-name="FRT Grill"
          d="M1.932,39.256,0,36.483l.22-8.211c.163-6.081.136-12.2-.027-18.3L.1,6.613Q.051,4.693,0,2.772L1.932,0c.725,5.615,1,19.628,1,19.628S2.657,33.641,1.932,39.256Z"
          transform="translate(697.61 215.06) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Grill-3"
          data-name="FRT Grill"
          transform="translate(852 147)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.frt_grill' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-35"
          data-name="3.0"
          transform="translate(832 145)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['wiper_blades'] || ''"
        [attr.data-name]="'exterior.microbus.wiper_blades' | translate"
      >
        <rect
          id="Rectangle_38-35"
          data-name="Rectangle 38"
          width="80"
          height="18"
          rx="9"
          transform="translate(510 224)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-36"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(580 224)"
        />
        <g class="parts" id="Protectives-2" data-name="Protectives">
          <path
            id="Path_640"
            data-name="Path 640"
            d="M4.327,45.6l1.76-16.761L4.049,26.694S2.859,39.655,1.656,41.461L0,41.611,3.043,0H4.049s1.384,14.964.278,24.493l3.245,3.95L5.432,45.6Z"
            transform="translate(709.111 280.675) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_639"
            data-name="Path 639"
            d="M4.075,12.045A2.516,2.516,0,0,1,2.768,9.707c0-1.75.654-9.707.654-9.707h-1.5S-.393,15.745.058,16.874a5.948,5.948,0,0,0,1.053,1.76Z"
            transform="translate(754.711 278.664) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_641"
            data-name="Path 641"
            d="M5.324,11.686s-2.245-.324-2.589-2.04S1.471,0,1.471,0L1.162.062,0,.294S1.629,16.086,2.294,17.1a31.174,31.174,0,0,0,3.031,3.274Z"
            transform="translate(701.489 273.676) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_642"
            data-name="Path 642"
            d="M10.208,44.658,8.644,27.878l-2.419-1.7s1.378,12.943.551,14.95L5.182,41.6,0,.2.986,0s4.293,14.4,5.08,23.962L10.023,27.2l1.269,17.243Z"
            transform="translate(657.047 283.496) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="_3.0-36"
          data-name="3.0"
          transform="translate(582 235)"
          fill="#030303"
          font-size="10"
          font-weight="800"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow-34" data-name="Arrow">
          <path
            id="Path_376"
            data-name="Path 376"
            d="M6292.577,1025.648l-108.835-45.992H6157"
            transform="translate(-5558.539 -746.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_107"
            data-name="Ellipse 107"
            cx="3"
            cy="3"
            r="3"
            transform="translate(731 276)"
            fill="#696969"
          />
        </g>
        <text
          id="Protectives-3"
          data-name="Protectives"
          transform="translate(522 236)"
          fill="#242e3a"
          font-size="10"
          font-weight="600"
        >
          <tspan x="0" y="0">
            {{ 'exterior.microbus.wiper_blades' | translate }}
          </tspan>
        </text>
      </g>
    </g>
  </svg>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : QC Passed
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : QC Failed
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part Change Needed)</option>
                <option [value]="2">2 (Major Repair Needed)</option>
                <option [value]="3">3 (Moderate Repair needed)</option>
                <option [value]="4">4 (Minor Repair Needed)</option>
                <option [value]="5">5 (Good Part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="!vehicleStatus || editableRole.includes(this.role) || role === 'qc'"
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn__primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>